import {Component, OnInit, Injector, ChangeDetectorRef, EventEmitter, Output} from '@angular/core';
import {CARDINFO, SUBSCRIPTIONINFO} from '../../../../gen/swagger-api';
import {Observable} from 'rxjs/Observable';
import {BsModalRef} from 'ngx-bootstrap';
import {HttpOperationsService} from '../../../shared/services/http-operations.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from '../modal-base-component';
import {DefaultService} from '../../../../gen/swagger-api/api/default.service';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {AlertService} from '../../../shared/services/alert.service';
import {SelectMsisdnComponent} from '../select-msisdn/select-msisdn.component';
import {ErrorHandlingService} from '../../../shared/services/error-handling-service';

@Component({
  selector: 'app-audit-modal',
  templateUrl: './audit-modal.component.html',
  styleUrls: ['./audit-modal.component.css']
})
export class AuditModalComponent extends ModalBaseComponent implements OnInit {

  subscriptions: Array<CARDINFO>;
  errors: any[] = [];
  public selectedSubscriptionIds = [];
  public selectedSubscriptionAll = [];
  callback;
  bsModalRef: BsModalRef;
  selectedSubscriptionInfo: SUBSCRIPTIONINFO;
  allSelected = false;
  @Output() action = new EventEmitter();
  changes = false;

  constructor(
    private inject: Injector,
    private _bsModalRef: BsModalRef,
    private defaultService: DefaultService,
    private httpOperationsService: HttpOperationsService,
    private readonly changeDetector: ChangeDetectorRef,
    private modalService: BsModalService,
    private alertService: AlertService,
    private errorHandlingService: ErrorHandlingService
  ) {
    super(inject);
  }

  ngOnInit(): void {
    // initialize with all subscriptions selected:
    this.changeDetector.detectChanges();
    this.subscriptions.forEach(element => {
      this.selectedSubscriptionIds.push(element.eis.eid);
    });
  }

  public confirm(): void {
    this.errors = [];
    const observables: Observable<any>[] = [];

    this.selectedSubscriptionIds.forEach(eid => {

    observables.push(this.defaultService.cardsEidAuditPost(eid));
    this.postAudit(observables, 'auditModal', this.callback);
    this.changes = true;
    this.closeModal();

    });
  }

  public closeModal(): void {
    if (this.changes) {
      this.action.emit(true);
    }
    this._bsModalRef.hide();
  }

  public openSelectMsisdnModal(subscription: CARDINFO) {
    let allSelected = false;

    if (this.selectedSubscriptionAll.includes(subscription.eis.eid)) {
      allSelected = true;
    }
    const initialState = {
      subscription,
      allSelected
    };
    this.bsModalRef = this.modalService.show(SelectMsisdnComponent, {initialState});
    this.bsModalRef.content.options.subscribe(result => {
      // this.selectedSubscriptionInfo = result.selectedSubscriptionInfo;

      for (let i = 0; i < this.subscriptions.length; i++) {
        if (this.subscriptions[i] === subscription) {
          if (result.selectedSubscriptionInfo) {
            if (this.subscriptions[i].currentSubscription) {
              this.subscriptions[i].currentSubscription.msisdn = result.selectedSubscriptionInfo.msisdn;
            } else {
              this.subscriptions[i].currentSubscription = result.selectedSubscriptionInfo;
            }

            this.selectedSubscriptionAll = this.selectedSubscriptionAll.filter(x => x !== this.subscriptions[i].eis.eid);
          } else {
            if (this.subscriptions[i].currentSubscription) {
              this.subscriptions[i].currentSubscription.msisdn = null;
            }
            this.selectedSubscriptionAll.push(this.subscriptions[i].eis.eid);
          }
        }
      }

      this.selectedSubscriptionInfo = result.selectedSubscriptionInfo;
      this.allSelected = result.allSelected;
      this.changeDetector.detectChanges();
    });
  }


  private postAudit(observables: Observable<any>[], operationName: string, successCallback?: () => void) {

    let errors = [];
    const successes = [];
    forkJoin(observables)
      .finally(
        () => {
          // filter out null elements
          errors = errors.filter(element => element !== null);
          if (errors.length === 0) {
            this.alertService.successModal(operationName + ' successful');
            if (successCallback && typeof successCallback === 'function') {
              successCallback();
            }
          } else {
            this.errorHandlingService.errorHandling(errors[0]);
          }
        }
      )
      .subscribe(
        result => {
          /*errors = error;
          console.log('error:' + JSON.stringify(error));*/
        },
        result => {
          // Handle result
          // console.log('result:' + JSON.stringify(result));
          if (result.status !== 200) {
            errors.push(result);
          } else {
            successes.push(result);
          }
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/audit-modal/audit-modal.component.ts